module.exports = "https://static.zego.com/_next/static/images/FleetCourier-d6e66cbbf96ee6cf1a42368bd724521b.svg";